import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppWindow, WINDOW } from '../../AppWindow';
import { EnterpriseConfigurationDataAccessService } from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';
import UtmTrackingParameters from '../../shared/classes/utm-tracking-parameters';
import { AbstractHeader } from '../abstract-header';

@Component({
  selector: 'app-unauthenticated-header',
  templateUrl: './unauthenticated-header.component.html',
  styleUrls: ['./unauthenticated-header.component.scss'],
})
export class UnauthenticatedHeaderComponent extends AbstractHeader implements OnInit {
  @HostBinding('class.site-header')
  public trialUrl = '';
  private _utmTrackingParameters!: UtmTrackingParameters;

  constructor(
    _enterpriseConfigurationService: EnterpriseConfigurationDataAccessService,
    _sanitizer: DomSanitizer,
    @Inject(WINDOW) private _window: AppWindow,
  ) {
    super(_enterpriseConfigurationService, _sanitizer);
    this.trialUrl = this.getTrialUrl();
  }

  ngOnInit() {
    this._utmTrackingParameters = UtmTrackingParameters.fromUrl(this._window.location.search);
  }

  navigateToSignUp() {
    const signUpUrl = this._window.portalConfig?.signUpUrl;

    if (typeof signUpUrl !== 'string') {
      return;
    }

    if (!this._utmTrackingParameters.hasAnyUtm()) {
      this._window.location.href = signUpUrl;
      return;
    }

    const separator = signUpUrl.includes('?') ? '&' : '?';
    this._window.location.href = signUpUrl + separator + this._utmTrackingParameters.toQueryString();
  }

  public onClick() {
    this._window.open(this.trialUrl, '_blank');
  }

  private getTrialUrl(): string {
    const host = this._window.location.hostname;

    if (host.includes('portal-dev.data.precisely.services')) {
      return 'https://developer-dev.cloud.precisely.com/';
    } else if (host.includes('data.precisely.com')) {
      return 'https://developer.cloud.precisely.com/';
    } else if (host.includes('data.precisely.services')) {
      return 'https://developer-stg.cloud.precisely.com/';
    } else {
      return 'https://developer-dev.cloud.precisely.com/';
    }
  }
}
